// Generouted, changes to this file will be overridden
/* eslint-disable */

import { components, hooks, utils } from "@generouted/react-router/client"

export type Path =
	| `/`
	| `/accounting/accounts`
	| `/accounting/accounts/:accountId`
	| `/accounting/accounts/:accountId/edit`
	| `/accounting/accounts/merge`
	| `/accounting/accounts/new`
	| `/accounting/bank-statements`
	| `/accounting/suspense-transactions`
	| `/accounting/suspense-transactions/new`
	| `/accounting/transactions`
	| `/accounting/transactions/csv-upload`
	| `/accounting/transactions/new`
	| `/admin/auth-logs`
	| `/admin/bank-accounts`
	| `/admin/credit-consumption`
	| `/admin/credit-consumption/ai-itinerary-builder`
	| `/admin/credit-consumption/ai-parsing`
	| `/admin/credit-consumption/all`
	| `/admin/credit-consumption/email-send`
	| `/admin/credit-consumption/mail-parsing`
	| `/admin/credit-consumption/tenants`
	| `/admin/pg/payment-links`
	| `/admin/pg/settlements`
	| `/admin/pg/transactions`
	| `/admin/teams`
	| `/admin/tenant-reports/churn-risk`
	| `/admin/tenant-reports/monthly`
	| `/admin/tenant-reports/monthly/users`
	| `/admin/tenants`
	| `/admin/tenants/:tenantId`
	| `/admin/tenants/:tenantId/auth-logs`
	| `/admin/tenants/:tenantId/billing`
	| `/admin/tenants/:tenantId/comments`
	| `/admin/tenants/:tenantId/comments/:status`
	| `/admin/tenants/:tenantId/configuration`
	| `/admin/tenants/:tenantId/login-activites`
	| `/admin/tenants/:tenantId/modules`
	| `/admin/tenants/:tenantId/stats`
	| `/admin/tenants/:tenantId/subscription-details`
	| `/admin/tenants/:tenantId/subscription-wallet`
	| `/admin/tenants/new`
	| `/admin/usage-stats`
	| `/admin/users`
	| `/admin/webhook-client-calls`
	| `/admin/world/airlines`
	| `/admin/world/airports`
	| `/admin/world/banks`
	| `/admin/world/banks/:bankId`
	| `/admin/world/countries`
	| `/admin/world/countries/:countryId`
	| `/admin/world/currency-exchange-rates`
	| `/admin/world/states/:stateId`
	| `/admin/world/timezones`
	| `/all-tasks`
	| `/automations/:automationId`
	| `/automations/:automationId/details`
	| `/automations/:automationId/edit`
	| `/automations/:automationId/runs`
	| `/automations/:automationId/schedules`
	| `/automations/new`
	| `/cab-price-calculation-metric-presets`
	| `/cab-price-calculation-metric-presets/:presetId`
	| `/cab-price-calculation-metric-presets/:presetId/edit`
	| `/cab-price-calculation-metric-presets/new`
	| `/cab-price-calculation-metrics`
	| `/cab-price-calculation-metrics/:metricId`
	| `/cab-price-calculation-metrics/new`
	| `/cab-schedules`
	| `/cab-schedules/:scheduleId`
	| `/cab-schedules/:scheduleId/edit`
	| `/cab-schedules/calendar`
	| `/cab-schedules/date/:date`
	| `/cab-schedules/new`
	| `/cab-types`
	| `/cabs`
	| `/cabs/:cabId`
	| `/cabs/new`
	| `/call-logs`
	| `/connection-requests/invite`
	| `/connection-requests/new`
	| `/connection-tenant-signup`
	| `/credit-consumption`
	| `/credit-consumption/ai-itinerary-builder`
	| `/credit-consumption/ai-parsing`
	| `/credit-consumption/all`
	| `/credit-consumption/email-send`
	| `/credit-consumption/mail-parsing`
	| `/customer-payment-preferences/new`
	| `/dashboard`
	| `/data-drive`
	| `/data-drive/folders/:folderId`
	| `/data-drive/folders/:folderId/files`
	| `/data-drive/folders/:folderId/files/:fileId`
	| `/data-drive/folders/:folderId/files/:fileId/compare/:versionId1/:versionId2/metric`
	| `/data-drive/folders/:folderId/files/:fileId/compare/:versionId1/:versionId2/transport`
	| `/data-drive/folders/:folderId/files/:fileId/versions/:versionId/edit/metric`
	| `/data-drive/folders/:folderId/files/:fileId/versions/:versionId/edit/transport`
	| `/data-drive/folders/:folderId/files/:fileId/versions/:versionId/view`
	| `/data-drive/folders/new/metric`
	| `/data-drive/folders/new/transport`
	| `/data-drive/folders/upload-prices/metric-sheets`
	| `/data-drive/folders/upload-prices/transport-sheets`
	| `/document-type/new`
	| `/email-verified`
	| `/forgot-password`
	| `/form`
	| `/form/tourist`
	| `/form/tourist/documents`
	| `/form/tourist/documents/:tripId`
	| `/hotel-bookings`
	| `/hotel-bookings/calendar`
	| `/hotel-check-in-outs`
	| `/hotel-groups`
	| `/hotel-groups/:groupId`
	| `/hotel-groups/:groupId/accountings`
	| `/hotel-groups/:groupId/bookings`
	| `/hotel-groups/:groupId/payments`
	| `/hotel-notes`
	| `/hotel-prices`
	| `/hotel-prices/calculate-price`
	| `/hotel-prices/new`
	| `/hotel-prices/upload-prices`
	| `/hotel-vouchers`
	| `/hotel-vouchers/new`
	| `/hotels`
	| `/hotels/:hotelId`
	| `/hotels/:hotelId/accounting`
	| `/hotels/:hotelId/bookings`
	| `/hotels/:hotelId/hotel-activities`
	| `/hotels/:hotelId/notes`
	| `/hotels/:hotelId/payments/incoming`
	| `/hotels/:hotelId/payments/outgoing`
	| `/hotels/merge`
	| `/hotels/new`
	| `/hotels/upload`
	| `/inclusion-exclusion-presets/:presetId`
	| `/inclusion-exclusion-presets/:presetId/edit`
	| `/inclusion-exclusion-presets/new`
	| `/integrations/:integrationId`
	| `/integrations/:integrationId/edit`
	| `/integrations/:integrationId/email-mailboxes/new`
	| `/integrations/:integrationId/mail`
	| `/integrations/:integrationId/mail/:folder`
	| `/integrations/:integrationId/mail/:folder/threads/:threadId`
	| `/integrations/:integrationId/mail/mailboxes`
	| `/integrations/:integrationId/oauth`
	| `/integrations/:integrationId/oauth/members`
	| `/integrations/:integrationId/oauth/permissions`
	| `/integrations/:integrationId/oauth/requests`
	| `/integrations/:integrationId/oauth/setup`
	| `/integrations/:integrationId/payu/:appId/update-credentials`
	| `/integrations/:integrationId/pg`
	| `/integrations/:integrationId/pg/configuration`
	| `/integrations/:integrationId/pg/payment-links`
	| `/integrations/:integrationId/pg/settlements`
	| `/integrations/:integrationId/pg/transactions`
	| `/integrations/:integrationId/tatatele/update-credentials`
	| `/integrations/:integrationId/whatsapp`
	| `/integrations/:integrationId/whatsapp/accounts`
	| `/integrations/:integrationId/whatsapp/automations`
	| `/integrations/:integrationId/whatsapp/automations/new`
	| `/integrations/:integrationId/whatsapp/flows`
	| `/integrations/:integrationId/whatsapp/flows/:flowId/edit`
	| `/integrations/:integrationId/whatsapp/flows/new`
	| `/integrations/:integrationId/whatsapp/messages`
	| `/integrations/:integrationId/whatsapp/quick-sends`
	| `/integrations/:integrationId/whatsapp/quick-sends/:quickSendId/edit`
	| `/integrations/:integrationId/whatsapp/quick-sends/new`
	| `/integrations/:integrationId/whatsapp/templates`
	| `/integrations/:integrationId/whatsapp/templates/:templateId/edit`
	| `/integrations/:integrationId/whatsapp/templates/new`
	| `/integrations/api/new`
	| `/integrations/callerdesk/new`
	| `/integrations/email-mailbox/new`
	| `/integrations/google-ads/new`
	| `/integrations/knowlarity/new`
	| `/integrations/meta/new`
	| `/integrations/new`
	| `/integrations/oauth/new`
	| `/integrations/payu/new`
	| `/integrations/pg-simulator/new`
	| `/integrations/tatatele/new`
	| `/integrations/whatsapp-cloud-api/new`
	| `/integrations/whatsapp-simulator/new`
	| `/invited-signup`
	| `/latest-release-notes`
	| `/locations`
	| `/locations/new`
	| `/login`
	| `/logout`
	| `/mail-messages`
	| `/meal-plans`
	| `/meal-plans/new`
	| `/notifications`
	| `/notifications/preferences`
	| `/onboarding`
	| `/onboarding/add-destinations`
	| `/onboarding/done`
	| `/onboarding/invite-users`
	| `/onboarding/upload-logo`
	| `/operational-bookings`
	| `/operational-bookings/calendar`
	| `/operational-bookings/date/:date`
	| `/org`
	| `/org/automations`
	| `/org/automations/definitions`
	| `/org/automations/runs`
	| `/org/automations/schedules`
	| `/org/bank-accounts`
	| `/org/cab-types`
	| `/org/connections`
	| `/org/currencies`
	| `/org/customer-payment-preferences`
	| `/org/document`
	| `/org/document/groups`
	| `/org/document/types`
	| `/org/inclusion-exclusion-presets`
	| `/org/integrations`
	| `/org/profile`
	| `/org/profile/:id`
	| `/org/report-activities`
	| `/org/supplier-payment-preferences`
	| `/org/supplier-payment-preferences/activity`
	| `/org/supplier-payment-preferences/hotel`
	| `/org/supplier-payment-preferences/transport`
	| `/org/tags`
	| `/org/tags/trips`
	| `/org/tax-types`
	| `/org/teams`
	| `/org/templates`
	| `/org/templates/activity-voucher-templates`
	| `/org/templates/hotel-booking-enquiry-email-template`
	| `/org/templates/invoice-templates`
	| `/org/templates/quote-email-templates`
	| `/org/templates/quote-pdf-templates`
	| `/org/templates/trip-voucher-templates`
	| `/org/terms-and-conditions`
	| `/org/tourists`
	| `/org/tourists/all`
	| `/org/tourists/profiles`
	| `/org/trip-destinations`
	| `/org/trip-sources`
	| `/org/users`
	| `/payments/gateway/settlements`
	| `/payments/gateway/transactions`
	| `/payments/incoming`
	| `/payments/instalments/:instalmentId`
	| `/payments/outgoing`
	| `/quote-requests`
	| `/register`
	| `/reset-password`
	| `/roles`
	| `/roles/:roleId`
	| `/roles/:roleId/edit`
	| `/roles/:roleId/edit-permissions`
	| `/roles/new`
	| `/room-types`
	| `/room-types/new`
	| `/search`
	| `/settings`
	| `/settings/apperance`
	| `/settings/security`
	| `/settings/security-logs`
	| `/supplier-payment-preferences/activity`
	| `/supplier-payment-preferences/activity/new`
	| `/supplier-payment-preferences/hotel`
	| `/supplier-payment-preferences/hotel/new`
	| `/supplier-payment-preferences/transport`
	| `/supplier-payment-preferences/transport/new`
	| `/suppliers`
	| `/suppliers/:supplierId`
	| `/suppliers/:supplierId/accounting`
	| `/suppliers/:supplierId/activities`
	| `/suppliers/:supplierId/bookings/cab-schedules`
	| `/suppliers/:supplierId/bookings/trip-wise-booking`
	| `/suppliers/:supplierId/hotels-bookings`
	| `/suppliers/:supplierId/payments/incoming`
	| `/suppliers/:supplierId/payments/outgoing`
	| `/suppliers/:supplierId/travel-activity-bookings`
	| `/suppliers/:supplierId/visas-bookings`
	| `/suppliers/activity`
	| `/suppliers/hotel`
	| `/suppliers/merge`
	| `/suppliers/new`
	| `/suppliers/transport`
	| `/suppliers/visa`
	| `/tags/trips/merge`
	| `/tags/trips/new`
	| `/teams/:teamId`
	| `/teams/:teamId/edit`
	| `/teams/new`
	| `/tenant-signup`
	| `/terms-and-conditions/:tncId`
	| `/terms-and-conditions/:tncId/edit`
	| `/terms-and-conditions/new`
	| `/tourist-profiles/:touristProfileId`
	| `/tourist-profiles/:touristProfileId/documents`
	| `/tourist-profiles/:touristProfileId/trips`
	| `/tourist-profiles/new`
	| `/transport-service-prices`
	| `/transport-service-prices/calculate-price`
	| `/transport-service-prices/new`
	| `/transport-service-prices/upload-prices`
	| `/transport-services`
	| `/transport-services/:serviceLocationId`
	| `/transport-services/:serviceLocationId/activities`
	| `/transport-services/new`
	| `/travel-activities`
	| `/travel-activities/:travelActivityId`
	| `/travel-activities/:travelActivityId/activities`
	| `/travel-activities/:travelActivityId/edit`
	| `/travel-activities/new`
	| `/travel-activity-prices`
	| `/travel-activity-prices/calculate-price`
	| `/travel-activity-prices/upload-prices`
	| `/trip-check-in-out-reports`
	| `/trip-destinations/:tripDestinationId`
	| `/trip-destinations/new`
	| `/trip-plan-requests`
	| `/trip-plan-requests/auto-distribution-preferences`
	| `/trip-plan-requests/report`
	| `/trip-quote-bookings-diff`
	| `/trip-sales-reports`
	| `/trip-sources/:tripSourceId`
	| `/trip-sources/:tripSourceId/accounting`
	| `/trip-sources/:tripSourceId/call-logs`
	| `/trip-sources/:tripSourceId/payments/incoming`
	| `/trip-sources/:tripSourceId/payments/outgoing`
	| `/trip-sources/:tripSourceId/trips`
	| `/trip-sources/merge`
	| `/trip-sources/new`
	| `/trip-sources/tags`
	| `/trips`
	| `/trips/:tripId`
	| `/trips/:tripId/accounting`
	| `/trips/:tripId/accounting/invoices`
	| `/trips/:tripId/accounting/payments`
	| `/trips/:tripId/accounting/transactions`
	| `/trips/:tripId/accounting/transactions/new`
	| `/trips/:tripId/activities`
	| `/trips/:tripId/ai-itinerary-builder`
	| `/trips/:tripId/ai-itinerary-builder/new-quote`
	| `/trips/:tripId/call-logs`
	| `/trips/:tripId/cancel`
	| `/trips/:tripId/comments`
	| `/trips/:tripId/comments/:status`
	| `/trips/:tripId/convert`
	| `/trips/:tripId/docs`
	| `/trips/:tripId/docs/activity-voucher`
	| `/trips/:tripId/docs/guests`
	| `/trips/:tripId/docs/hotels-voucher`
	| `/trips/:tripId/docs/trip-holding-email`
	| `/trips/:tripId/docs/trip-voucher`
	| `/trips/:tripId/drop`
	| `/trips/:tripId/edit`
	| `/trips/:tripId/emails`
	| `/trips/:tripId/new-quote`
	| `/trips/:tripId/quote-requests/new`
	| `/trips/:tripId/quotes`
	| `/trips/:tripId/quotes/:quoteId`
	| `/trips/:tripId/quotes/:quoteId/edit-itinerary`
	| `/trips/:tripId/select-quote`
	| `/trips/:tripId/services-bookings`
	| `/trips/:tripId/services-bookings/:serviceType`
	| `/trips/:tripId/services-bookings/operational/new`
	| `/trips/:tripId/whatsapp`
	| `/trips/:tripId/whatsapp/:threadId`
	| `/trips/new`
	| `/trips/upload`
	| `/users/:userId`
	| `/users/:userId/edit`
	| `/users/:userId/edit-roles`
	| `/users/new`
	| `/visa`
	| `/visa-bookings`
	| `/visa/:visaServiceId`
	| `/visa/:visaServiceId/activities`
	| `/visa/:visaServiceId/edit`
	| `/visa/new`
	| `/whatsapp/inbox`
	| `/whatsapp/inbox/:threadId`

export type Params = {
	"/accounting/accounts/:accountId": { accountId: string }
	"/accounting/accounts/:accountId/edit": { accountId: string }
	"/admin/tenants/:tenantId": { tenantId: string }
	"/admin/tenants/:tenantId/auth-logs": { tenantId: string }
	"/admin/tenants/:tenantId/billing": { tenantId: string }
	"/admin/tenants/:tenantId/comments": { tenantId: string }
	"/admin/tenants/:tenantId/comments/:status": {
		tenantId: string
		status: string
	}
	"/admin/tenants/:tenantId/configuration": { tenantId: string }
	"/admin/tenants/:tenantId/login-activites": { tenantId: string }
	"/admin/tenants/:tenantId/modules": { tenantId: string }
	"/admin/tenants/:tenantId/stats": { tenantId: string }
	"/admin/tenants/:tenantId/subscription-details": { tenantId: string }
	"/admin/tenants/:tenantId/subscription-wallet": { tenantId: string }
	"/admin/world/banks/:bankId": { bankId: string }
	"/admin/world/countries/:countryId": { countryId: string }
	"/admin/world/states/:stateId": { stateId: string }
	"/automations/:automationId": { automationId: string }
	"/automations/:automationId/details": { automationId: string }
	"/automations/:automationId/edit": { automationId: string }
	"/automations/:automationId/runs": { automationId: string }
	"/automations/:automationId/schedules": { automationId: string }
	"/cab-price-calculation-metric-presets/:presetId": { presetId: string }
	"/cab-price-calculation-metric-presets/:presetId/edit": { presetId: string }
	"/cab-price-calculation-metrics/:metricId": { metricId: string }
	"/cab-schedules/:scheduleId": { scheduleId: string }
	"/cab-schedules/:scheduleId/edit": { scheduleId: string }
	"/cab-schedules/date/:date": { date: string }
	"/cabs/:cabId": { cabId: string }
	"/data-drive/folders/:folderId": { folderId: string }
	"/data-drive/folders/:folderId/files": { folderId: string }
	"/data-drive/folders/:folderId/files/:fileId": {
		folderId: string
		fileId: string
	}
	"/data-drive/folders/:folderId/files/:fileId/compare/:versionId1/:versionId2/metric": {
		folderId: string
		fileId: string
		versionId1: string
		versionId2: string
	}
	"/data-drive/folders/:folderId/files/:fileId/compare/:versionId1/:versionId2/transport": {
		folderId: string
		fileId: string
		versionId1: string
		versionId2: string
	}
	"/data-drive/folders/:folderId/files/:fileId/versions/:versionId/edit/metric": {
		folderId: string
		fileId: string
		versionId: string
	}
	"/data-drive/folders/:folderId/files/:fileId/versions/:versionId/edit/transport": {
		folderId: string
		fileId: string
		versionId: string
	}
	"/data-drive/folders/:folderId/files/:fileId/versions/:versionId/view": {
		folderId: string
		fileId: string
		versionId: string
	}
	"/form/tourist/documents/:tripId": { tripId: string }
	"/hotel-groups/:groupId": { groupId: string }
	"/hotel-groups/:groupId/accountings": { groupId: string }
	"/hotel-groups/:groupId/bookings": { groupId: string }
	"/hotel-groups/:groupId/payments": { groupId: string }
	"/hotels/:hotelId": { hotelId: string }
	"/hotels/:hotelId/accounting": { hotelId: string }
	"/hotels/:hotelId/bookings": { hotelId: string }
	"/hotels/:hotelId/hotel-activities": { hotelId: string }
	"/hotels/:hotelId/notes": { hotelId: string }
	"/hotels/:hotelId/payments/incoming": { hotelId: string }
	"/hotels/:hotelId/payments/outgoing": { hotelId: string }
	"/inclusion-exclusion-presets/:presetId": { presetId: string }
	"/inclusion-exclusion-presets/:presetId/edit": { presetId: string }
	"/integrations/:integrationId": { integrationId: string }
	"/integrations/:integrationId/edit": { integrationId: string }
	"/integrations/:integrationId/email-mailboxes/new": { integrationId: string }
	"/integrations/:integrationId/mail": { integrationId: string }
	"/integrations/:integrationId/mail/:folder": {
		integrationId: string
		folder: string
	}
	"/integrations/:integrationId/mail/:folder/threads/:threadId": {
		integrationId: string
		folder: string
		threadId: string
	}
	"/integrations/:integrationId/mail/mailboxes": { integrationId: string }
	"/integrations/:integrationId/oauth": { integrationId: string }
	"/integrations/:integrationId/oauth/members": { integrationId: string }
	"/integrations/:integrationId/oauth/permissions": { integrationId: string }
	"/integrations/:integrationId/oauth/requests": { integrationId: string }
	"/integrations/:integrationId/oauth/setup": { integrationId: string }
	"/integrations/:integrationId/payu/:appId/update-credentials": {
		integrationId: string
		appId: string
	}
	"/integrations/:integrationId/pg": { integrationId: string }
	"/integrations/:integrationId/pg/configuration": { integrationId: string }
	"/integrations/:integrationId/pg/payment-links": { integrationId: string }
	"/integrations/:integrationId/pg/settlements": { integrationId: string }
	"/integrations/:integrationId/pg/transactions": { integrationId: string }
	"/integrations/:integrationId/tatatele/update-credentials": {
		integrationId: string
	}
	"/integrations/:integrationId/whatsapp": { integrationId: string }
	"/integrations/:integrationId/whatsapp/accounts": { integrationId: string }
	"/integrations/:integrationId/whatsapp/automations": { integrationId: string }
	"/integrations/:integrationId/whatsapp/automations/new": {
		integrationId: string
	}
	"/integrations/:integrationId/whatsapp/flows": { integrationId: string }
	"/integrations/:integrationId/whatsapp/flows/:flowId/edit": {
		integrationId: string
		flowId: string
	}
	"/integrations/:integrationId/whatsapp/flows/new": { integrationId: string }
	"/integrations/:integrationId/whatsapp/messages": { integrationId: string }
	"/integrations/:integrationId/whatsapp/quick-sends": { integrationId: string }
	"/integrations/:integrationId/whatsapp/quick-sends/:quickSendId/edit": {
		integrationId: string
		quickSendId: string
	}
	"/integrations/:integrationId/whatsapp/quick-sends/new": {
		integrationId: string
	}
	"/integrations/:integrationId/whatsapp/templates": { integrationId: string }
	"/integrations/:integrationId/whatsapp/templates/:templateId/edit": {
		integrationId: string
		templateId: string
	}
	"/integrations/:integrationId/whatsapp/templates/new": {
		integrationId: string
	}
	"/operational-bookings/date/:date": { date: string }
	"/org/profile/:id": { id: string }
	"/payments/instalments/:instalmentId": { instalmentId: string }
	"/roles/:roleId": { roleId: string }
	"/roles/:roleId/edit": { roleId: string }
	"/roles/:roleId/edit-permissions": { roleId: string }
	"/suppliers/:supplierId": { supplierId: string }
	"/suppliers/:supplierId/accounting": { supplierId: string }
	"/suppliers/:supplierId/activities": { supplierId: string }
	"/suppliers/:supplierId/bookings/cab-schedules": { supplierId: string }
	"/suppliers/:supplierId/bookings/trip-wise-booking": { supplierId: string }
	"/suppliers/:supplierId/hotels-bookings": { supplierId: string }
	"/suppliers/:supplierId/payments/incoming": { supplierId: string }
	"/suppliers/:supplierId/payments/outgoing": { supplierId: string }
	"/suppliers/:supplierId/travel-activity-bookings": { supplierId: string }
	"/suppliers/:supplierId/visas-bookings": { supplierId: string }
	"/teams/:teamId": { teamId: string }
	"/teams/:teamId/edit": { teamId: string }
	"/terms-and-conditions/:tncId": { tncId: string }
	"/terms-and-conditions/:tncId/edit": { tncId: string }
	"/tourist-profiles/:touristProfileId": { touristProfileId: string }
	"/tourist-profiles/:touristProfileId/documents": { touristProfileId: string }
	"/tourist-profiles/:touristProfileId/trips": { touristProfileId: string }
	"/transport-services/:serviceLocationId": { serviceLocationId: string }
	"/transport-services/:serviceLocationId/activities": {
		serviceLocationId: string
	}
	"/travel-activities/:travelActivityId": { travelActivityId: string }
	"/travel-activities/:travelActivityId/activities": {
		travelActivityId: string
	}
	"/travel-activities/:travelActivityId/edit": { travelActivityId: string }
	"/trip-destinations/:tripDestinationId": { tripDestinationId: string }
	"/trip-sources/:tripSourceId": { tripSourceId: string }
	"/trip-sources/:tripSourceId/accounting": { tripSourceId: string }
	"/trip-sources/:tripSourceId/call-logs": { tripSourceId: string }
	"/trip-sources/:tripSourceId/payments/incoming": { tripSourceId: string }
	"/trip-sources/:tripSourceId/payments/outgoing": { tripSourceId: string }
	"/trip-sources/:tripSourceId/trips": { tripSourceId: string }
	"/trips/:tripId": { tripId: string }
	"/trips/:tripId/accounting": { tripId: string }
	"/trips/:tripId/accounting/invoices": { tripId: string }
	"/trips/:tripId/accounting/payments": { tripId: string }
	"/trips/:tripId/accounting/transactions": { tripId: string }
	"/trips/:tripId/accounting/transactions/new": { tripId: string }
	"/trips/:tripId/activities": { tripId: string }
	"/trips/:tripId/ai-itinerary-builder": { tripId: string }
	"/trips/:tripId/ai-itinerary-builder/new-quote": { tripId: string }
	"/trips/:tripId/call-logs": { tripId: string }
	"/trips/:tripId/cancel": { tripId: string }
	"/trips/:tripId/comments": { tripId: string }
	"/trips/:tripId/comments/:status": { tripId: string; status: string }
	"/trips/:tripId/convert": { tripId: string }
	"/trips/:tripId/docs": { tripId: string }
	"/trips/:tripId/docs/activity-voucher": { tripId: string }
	"/trips/:tripId/docs/guests": { tripId: string }
	"/trips/:tripId/docs/hotels-voucher": { tripId: string }
	"/trips/:tripId/docs/trip-holding-email": { tripId: string }
	"/trips/:tripId/docs/trip-voucher": { tripId: string }
	"/trips/:tripId/drop": { tripId: string }
	"/trips/:tripId/edit": { tripId: string }
	"/trips/:tripId/emails": { tripId: string }
	"/trips/:tripId/new-quote": { tripId: string }
	"/trips/:tripId/quote-requests/new": { tripId: string }
	"/trips/:tripId/quotes": { tripId: string }
	"/trips/:tripId/quotes/:quoteId": { tripId: string; quoteId: string }
	"/trips/:tripId/quotes/:quoteId/edit-itinerary": {
		tripId: string
		quoteId: string
	}
	"/trips/:tripId/select-quote": { tripId: string }
	"/trips/:tripId/services-bookings": { tripId: string }
	"/trips/:tripId/services-bookings/:serviceType": {
		tripId: string
		serviceType: string
	}
	"/trips/:tripId/services-bookings/operational/new": { tripId: string }
	"/trips/:tripId/whatsapp": { tripId: string }
	"/trips/:tripId/whatsapp/:threadId": { tripId: string; threadId: string }
	"/users/:userId": { userId: string }
	"/users/:userId/edit": { userId: string }
	"/users/:userId/edit-roles": { userId: string }
	"/visa/:visaServiceId": { visaServiceId: string }
	"/visa/:visaServiceId/activities": { visaServiceId: string }
	"/visa/:visaServiceId/edit": { visaServiceId: string }
	"/whatsapp/inbox/:threadId": { threadId: string }
}

export type ModalPath = never

export const { Link, Navigate } = components<Path, Params>()
export const { useModals, useNavigate, useParams } = hooks<
	Path,
	Params,
	ModalPath
>()
export const { redirect } = utils<Path, Params>()
